var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useRef, useState } from 'react';
import { ButtonElement, ChevronWrapper, IconWrapper, AccordionSectionText, AccordionSectionHeader, AccordionSectionSubheader, AccordionSectionWrapper, AccordionSectionContent, RotatingIcon, NumberWrapper, } from './AccordionSectionElements';
import { Icon } from '../Icon';
import { DEFAULT_TRANSITION_TIME, DEFAULT_TRANSITION_TIMING_FUNCTION, DEFAULT_TRANSITION_MAX_HEIGHT, } from './AccordionConsts';
import { useCurrentAccordionIndex } from './hooks/useCurrentAccordionIndex';
import AccordionContext from './AccordionContext';
import { Text } from '../Text';
export var AccordionSection = React.forwardRef(function (_a, fRef) {
    var _b = _a.buttonClassName, buttonClassName = _b === void 0 ? '' : _b, _c = _a.iconWrapperClassName, iconWrapperClassName = _c === void 0 ? '' : _c, _d = _a.ariaLabel, ariaLabel = _d === void 0 ? '' : _d, id = _a.id, iconSrc = _a.iconSrc, children = _a.children, header = _a.header, subheader = _a.subheader, _e = _a.startOpen, startOpen = _e === void 0 ? false : _e, _f = _a.transitionMaxHeight, transitionMaxHeight = _f === void 0 ? DEFAULT_TRANSITION_MAX_HEIGHT : _f, _g = _a.transitionDuration, transitionDuration = _g === void 0 ? DEFAULT_TRANSITION_TIME : _g, _h = _a.transitionTimingFunction, transitionTimingFunction = _h === void 0 ? DEFAULT_TRANSITION_TIMING_FUNCTION : _h, onClick = _a.onClick, onOpenStateChange = _a.onOpenStateChange, rest = __rest(_a, ["buttonClassName", "iconWrapperClassName", "ariaLabel", "id", "iconSrc", "children", "header", "subheader", "startOpen", "transitionMaxHeight", "transitionDuration", "transitionTimingFunction", "onClick", "onOpenStateChange"]);
    var numbered = useContext(AccordionContext).numbered;
    var accordionRef = useRef(null);
    var accordionIndex = useCurrentAccordionIndex(accordionRef);
    var _j = useState(startOpen), accordionOpen = _j[0], setAccordionOpenState = _j[1];
    var renderIcon = function () { return (React.createElement(IconWrapper, { className: iconWrapperClassName },
        React.createElement(Icon, { src: iconSrc, fill: "currentColor", size: "large" }))); };
    var renderNumber = function () { return (React.createElement(NumberWrapper, { "data-testid": "accordion-section-index-".concat(accordionIndex) },
        React.createElement(Text, { weight: "heavy", size: 2 },
            accordionIndex,
            "."))); };
    var headerLeftPadding = iconSrc || numbered ? '0' : '1rem';
    var contentLeftPadding = iconSrc || numbered ? '3.5rem' : '1rem';
    var contentBottomPadding = accordionOpen ? '.75rem' : '0';
    var contentMaxHeight = accordionOpen ? transitionMaxHeight : '0';
    var contentOpacity = accordionOpen ? '100' : '0';
    return (React.createElement(AccordionSectionWrapper, { ref: accordionRef },
        React.createElement(ButtonElement, __assign({ ref: fRef, id: id, className: buttonClassName, "aria-label": ariaLabel, "aria-expanded": accordionOpen, onClick: function (e) {
                onClick === null || onClick === void 0 ? void 0 : onClick(e);
                onOpenStateChange === null || onOpenStateChange === void 0 ? void 0 : onOpenStateChange(!accordionOpen);
                setAccordionOpenState(!accordionOpen);
            } }, rest),
            numbered ? renderNumber() : iconSrc && renderIcon(),
            React.createElement(AccordionSectionText, { "data-testid": "accordion-section-text-".concat(id), style: { paddingLeft: headerLeftPadding } },
                React.createElement(AccordionSectionHeader, null, header),
                subheader && (React.createElement(AccordionSectionSubheader, null, subheader))),
            React.createElement(ChevronWrapper, null,
                React.createElement(RotatingIcon, { src: 'ChevronDown', size: "large", fill: "currentColor", rotateIcon: accordionOpen }))),
        React.createElement(AccordionSectionContent, { "aria-hidden": !accordionOpen, style: {
                paddingBottom: contentBottomPadding,
                paddingLeft: contentLeftPadding,
                maxHeight: contentMaxHeight,
                opacity: contentOpacity,
                transition: "all ".concat(transitionDuration, " ").concat(transitionTimingFunction)
            } }, children)));
});
